import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApplicationPropertyObj, MxApplicationPropertiesService} from 'mx-core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators/map';

const APPLICATION_PROPERTIES_REST_URL: string = '/rest/properties';

@Injectable({
    providedIn: 'root'
})
export class PrlApplicationPropertiesDataService implements MxApplicationPropertiesService {

    constructor(
        private httpClient: HttpClient
    ) {}

    public getProperty(name: string): Observable<string> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/${name}`, {responseType: 'text'});
    }

    public getProperties(): Observable<Array<ApplicationPropertyObj>> {
        return this.httpClient.get<Array<ApplicationPropertyObj>>(APPLICATION_PROPERTIES_REST_URL);
    }

    public addProperty(property: ApplicationPropertyObj): Observable<ApplicationPropertyObj> {
        return this.httpClient.post<ApplicationPropertyObj>(APPLICATION_PROPERTIES_REST_URL, property);
    }

    public updateProperty(id: number, property: ApplicationPropertyObj): Observable<ApplicationPropertyObj> {
        return this.httpClient.put<ApplicationPropertyObj>(APPLICATION_PROPERTIES_REST_URL + '/' + id, property);
    }

    public removeProperties(ids: Array<number>): Observable<Array<number>> {
        return this.httpClient.delete<Array<number>>(APPLICATION_PROPERTIES_REST_URL + `/delete?ids=${ids}`);
    }

    public getBooleanProperty(name: string): Observable<boolean> {
        return this.getProperty(name)
            .pipe(
                map(value => value.toLowerCase() === 'true')
            );
    }

    public isEnableVatPayer(): Observable<boolean> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/is-enable-vat-payer`, {responseType: 'text'}).pipe(
            map(this.stringToBoolean)
        );
    }

    public isShowDetailedSignup(): Observable<boolean> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/is-show-detailed-signup`, {responseType: 'text'}).pipe(
            map(this.stringToBoolean)
        );
    }

    public isAccessByProduct(): Observable<boolean> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/is-access-by-product`, {responseType: 'text'}).pipe(
            map(this.stringToBoolean)
        );
    }

    public isRegistrationDisabled(): Observable<boolean> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/is-registration-disabled`, {responseType: 'text'}).pipe(
            map(this.stringToBoolean)
        );
    }

    public isUsingCaptcha(): Observable<boolean> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/is-using-captcha`, {responseType: 'text'}).pipe(
            map(this.stringToBoolean)
        );
    }

    public showSendPromotions(): Observable<boolean> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/show-send-promotions`, {responseType: 'text'}).pipe(
            map(this.stringToBoolean)
        );
    }

    public getCaptchaKey(): Observable<string> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/captcha-key`, {responseType: 'text'});
    }

    public getDefaultCountry(): Observable<string> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/portal-default-country`, {responseType: 'text'});
    }

    public getDefaultLanguage(): Observable<string> {
        return this.httpClient.get(`${APPLICATION_PROPERTIES_REST_URL}/portal-default-language`, {responseType: 'text'});
    }

    private stringToBoolean = (value: string): boolean => value.toLowerCase() === 'true';
}
